/**
 * Composant pour afficher un statut (succès ou erreur)
 * @module admin/components/AdminStatus
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Composant d'affichage de statut
 * @param {Object} props
 * @param {boolean} props.isOk - Si true, affiche un statut de succès
 * @param {string} props.message - Message à afficher
 * @param {string} [props.icon] - Icône personnalisée
 * @param {string} [props.className] - Classes CSS supplémentaires
 * @returns {JSX.Element}
 */
const AdminStatus = ({ isOk, message, icon, className = '' }) => {
  const statusClass = isOk ? 'admin-status-ok' : 'admin-status-error';
  const defaultIcon = isOk ? '✓' : '✗';

  return (
    <div className={`admin-status ${statusClass} ${className}`}>
      <span className="admin-status-icon">{icon || defaultIcon}</span>
      <span>{message}</span>
    </div>
  );
};

AdminStatus.propTypes = {
  isOk: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  icon: PropTypes.string,
  className: PropTypes.string,
};

export default AdminStatus;
